import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/analytics';

import { Singleton } from '@denishussar/html5-game-engine';

export interface UserProps {
    name: string;
    score: number;
    achievements: string[];
}

const ATOM_TRIP_DEMO_PATH = 'demo/atomTrip/';
const USERS_COLLECTION_PATH = ATOM_TRIP_DEMO_PATH + 'users';

@Singleton
export class FirebaseAPI {
    private _db: firebase.firestore.Firestore = null;
    private _analyticsParams: any = {};

    public init(): void {
        firebase.initializeApp({
            apiKey: "AIzaSyCoc5Ym-nvBLE5IvsNUyjs6C5_YjQsTYUc",
            authDomain: "nord-beaver.firebaseapp.com",
            projectId: "nord-beaver",
            storageBucket: "nord-beaver.appspot.com",
            messagingSenderId: "204061968274",
            appId: "1:204061968274:web:06a58a79a929a382a7e34b"
        });

        this._db = firebase.firestore();
    }

    public async load(id: string): Promise<UserProps> {
        if (id !== '') {
            const doc = await this._db.collection(USERS_COLLECTION_PATH).doc(id);
            const snapshot = await doc.get();

            if (snapshot.exists) {
                const data = snapshot.data() as UserProps;

                console.log('load', id, data);

                return data;
            }
        }

        return null;
    }

    public async save(props): Promise<string> {
        console.log('saveUserData', props);

        // if (id !== '') {
        //     const doc = await this._db.collection(USERS_COLLECTION_PATH).doc(id);
        //     const snapshot = await doc.get();
        //
        //     if (snapshot.exists) {
        //         doc.update(props);
        //
        //         return id;
        //     }
        // }

        const doc = await this._db.collection(USERS_COLLECTION_PATH).add(props);

        return doc.id;
    }

    public async getUsers(): Promise<Map<string, UserProps>> {
        const map = new Map();
        const snapshot = await this._db.collection(USERS_COLLECTION_PATH).get();

        for (let i = 0; i < snapshot.docs.length; i++) {
            const doc = snapshot.docs[i];

            map.set(doc.id, doc.data());
        }

        return map;
    }

    public setAnalyticsParams(analyticsParams: any): void {
        this._analyticsParams = analyticsParams;
        firebase.analytics().setUserProperties(this._analyticsParams);
    }

    public trackGameStart(): void {
        firebase.analytics().logEvent('play-game_click', { ...this._analyticsParams, 'click': 'click' });
    }

    public trackGameRestart(endType: string): void {
        firebase.analytics().logEvent(`end_${endType}_play-again`, { ...this._analyticsParams, 'play-again': 'play-again' });
    }

    public trackVote(endType: string): void {
        firebase.analytics().logEvent(`end_${endType}_vote`, { ...this._analyticsParams, 'vote': 'vote' });
    }
}
